export default "/media/Search_Results.png";